/**
 * Przy użyciu globalnej zmiennej, próbujemy pobrać serwisy z biblioteki vue3-components. Jeśli nie są dostępne, korzystamy z lokalnych importów
 * Jest to spowodowane przez to, że form-layout z CDN nie ma dostępu do importów z vue3-components i wtedy wykorzystane zostaną serwisy z globalnej zmiennej
 * @param serviceName Nazwa serwisu, który chcemy pobrać z globalnej zmiennej
 * @param fallback Serwis, który zostanie wykorzystany, jeśli globalna zmienna nie będzie zawierała szukanego serwisu
 * @returns Serwis z vue3-components, jeśli jest dostępny globalnie, w przeciwnym wypadku zwraca lokalnie importowany serwis
 */
export function getFromVue3Compontents<T>(serviceName: string, fallback: T): T {
  return (globalThis as any)?.vue3Components?.[serviceName] ?? fallback;
}
